










































































































import { JournalEntry } from "../../models/JournalEntry";
import TableFilters from "../../core/Table/TableFilters.vue";
import { TableColumn } from "../../models/UI/TableColumn";
import { Option } from "../../models/Option";
import { ListParamApi } from "../../api/ListParamApi";
import { ContactApi } from "../../api/ContactApi";
import TableSort from "../../core/Table/TableSort.vue";
import UIActionType = JournalEntry.UIActionType;
import { EmployeApi } from "../../api/EmployeApi";
import { Intervention } from "../../models/Intervention";
import JournalNoteButton from "../../note/JournalNoteButton.vue";

export default {
    name: "JournalFilters",
    components: { JournalNoteButton, TableSort, TableFilters },
    props: {
        metadata: Object,
        value: Object,
    },
    data() {
        return {
            filters: {},
            selectedFilter: null,
            taskView: false,
            selectedCategory: JournalEntry.ECategory.General,
            CategoryFilters: JournalEntry.CategoryFilters,
            EStatus: JournalEntry.EStatus,
            ListParamApi: new ListParamApi(),
            ContactApi: new ContactApi(),
            EmployeApi: new EmployeApi(),
            columns: [
                {
                    id: "creationDate",
                    name: "Date de création",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "created_at",
                },
                {
                    id: "updateDate",
                    name: "Date de mise à jour",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "updated_at",
                },
                {
                    id: "creator",
                    name: "Créateur de la demande",
                    type: TableColumn.ColumnType.text,
                    sort_field: "creator_id",
                },
                {
                    id: "clientIds",
                    name: "Client",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "clients.nom",
                },
                {
                    id: "objectIds",
                    name: "Objet",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "list_params.name",
                },
                {
                    id: "description",
                    name: "Description",
                    type: TableColumn.ColumnType.text,
                    sort_field: "description",
                },
                {
                    id: "employeIds",
                    name: "Employé",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "employes.nom",
                },
                {
                    id: "recipient",
                    name: "Suivi par",
                    type: TableColumn.ColumnType.text,
                    sort_field: "recipient_employes.nom",
                },
                {
                    id: "dateEcheance",
                    name: "Échéance",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "date_echeance",
                },
                {
                    id: "interventionStatus",
                    name: "Status intervention",
                    type: TableColumn.ColumnType.option,
                    options: [],
                },
                {
                    id: "interventionNotified",
                    name: "Intervention prioritaire",
                    type: TableColumn.ColumnType.boolean,
                },
            ],
        };
    },
    created() {
        let self = this;

        self.ListParamApi.getAll({
            type: Option.EListParamType.journal_entry_object,
        }).then(function (res) {
            let col = _.find(self.columns, { id: "objectIds" });
            col.options = Option.toTags(res);
        });
        self.ContactApi.getAllAsOptions({
            useCache: true,
        }).then(function (res) {
            let col = _.find(self.columns, { id: "clientIds" });
            col.options = Option.toTags(res);
            let coproprietes_sensibles_ids = _.chain(res)
                .filter(function (c) {
                    return c.classes === "important-tag";
                })
                .map("id")
                .value();
            col.options.push({
                ids: coproprietes_sensibles_ids,
                text: "Copropriétés sensibles",
                classes: "group-tag",
            });
        });
        self.EmployeApi.getAllAsOptions().then(function (res) {
            let col = _.find(self.columns, { id: "employeIds" });
            col.options = Option.toTags(res);
        });
        let col = _.find(self.columns, { id: "interventionStatus" });
        col.options = Intervention.Etat;
    },
    methods: {
        toggleTaskView(): void {
            this.taskView = !this.taskView;
            this.$emit("input", this.getFilters());
        },
        selectCategory(category): void {
            if (this.selectedCategory === category) {
                return;
            }
            this.selectedCategory = category;
            this.$emit("input", this.getFilters());
        },
        selectFilter(f: JournalEntry.EStatus): void {
            if (this.selectedFilter === f) {
                this.selectedFilter = null;
            } else {
                this.selectedFilter = f;
            }
            this.$emit("input", this.getFilters());
        },
        addComment(): void {
            this.$emit("action", UIActionType.create_entry);
        },
        addAbsence(): void {
            this.$emit("action", UIActionType.create_absence);
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", this.getFilters());
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
        getFilters() {
            if (_.isNull(this.selectedFilter)) {
                return _.merge({}, this.filters, {
                    taskView: this.taskView,
                    category: this.selectedCategory,
                });
            } else {
                return _.merge({}, this.filters, {
                    status: this.selectedFilter,
                    taskView: this.taskView,
                    category: this.selectedCategory,
                });
            }
        },
    },
    watch: {
        // Synchronise le bouton actif quand la catégorie est imposée de
        // l'extérieur (ex. lien direct vers un dossier).
        "value.category": function (category): void {
            if (category !== undefined && category !== this.selectedCategory) {
                this.selectedCategory = category;
            }
        },
    },
};
